import { Injectable } from "@angular/core";
import { CommonApiService } from "./common-api.service";
import { APIURL } from "../global/constant";

@Injectable({
  providedIn: "root",
})
export class CompanyService {
  constructor(private commonApiService: CommonApiService) {}

  saveKnowledgeBase(payload: FormData) {
    return this.commonApiService.post(APIURL.knowledgeBaseSave, payload);
  }

  getCompanyUserList() {
    return this.commonApiService.get(APIURL.companyUserList);
  }

  admindashboard(payload) {
    const params = this.commonApiService.getParamsFromObj(payload);
    return this.commonApiService.get(APIURL.admin_dashboard, params);
  }

  getadmincompanies(payload) {
    const params = this.commonApiService.getParamsFromObj(payload);
    return this.commonApiService.get(APIURL.admin_companies, params);
  }
 
  getadmincompanydetail(payload) {
    const params = this.commonApiService.getParamsFromObj(payload);
    return this.commonApiService.get(APIURL.admin_companydetail+"/" + payload?.company_id, params);
  }

  adjustCredits(payload) {
    return this.commonApiService.post(APIURL.admin_adjust_credits, payload);
  }

  
   getadminteammembers(payload) {
    const params = this.commonApiService.getParamsFromObj(payload);
    return this.commonApiService.get(APIURL.admin_teammembers+"/" + payload?.company_id, params);
  }

  admin_teammembersinvites(payload) {
    const params = this.commonApiService.getParamsFromObj(payload);
    return this.commonApiService.get(APIURL.admin_teammembersinvites+"/" + payload?.company_id, params);
  }

  getadmintransactions(payload) {
    const params = this.commonApiService.getParamsFromObj(payload);
    return this.commonApiService.get(APIURL.admin_transactions+"/" + payload?.company_id, params);
  }

  toggleSuspend(payload) {
    return this.commonApiService.post(APIURL.admin_toggle_suspend, payload);
  }

  updateCompanyCreditPolicy(payload: {
    company_id: number;
    bypass_credit_checks?: boolean;
    allow_credit_overage?: boolean;
    max_credit_overage?: number;
  }) {
    return this.commonApiService.post(
      APIURL.admin_company_credit_policy,
      payload,
    );
  }

  updateMemberCreditBypass(payload: {
    company_id: number;
    user_id: number;
    bypass_credit_checks: boolean;
  }) {
    return this.commonApiService.post(
      APIURL.admin_company_user_credit_policy,
      payload,
    );
  }

  updateMemberCreditAlerts(payload: {
    company_id: number;
    user_id: number;
    receive_credit_alerts: boolean;
  }) {
    return this.commonApiService.post(
      APIURL.admin_company_user_credit_alerts,
      payload,
    );
  }

  createAdminOrganization(payload) {
    return this.commonApiService.post(APIURL.admin_organization_create, payload);
  }

  deleteAdminOrganization(payload) {
    return this.commonApiService.post(APIURL.admin_organization_delete, payload);
  }

  adminOrganizationInvitations(payload) {
    return this.commonApiService.post(APIURL.admin_organization_invitations, payload);
  }

  adminOrganizationInvitationResend(payload) {
    return this.commonApiService.post(
      APIURL.admin_organization_invitations_resend,
      payload,
    );
  }

  adminOrganizationInvitationDelete(payload) {
    return this.commonApiService.post(
      APIURL.admin_organization_invitations_delete,
      payload,
    );
  }

  adminOrganizationRemoveMember(payload) {
    return this.commonApiService.post(
      APIURL.admin_organization_remove_member,
      payload,
    );
  }

  adminOrganizationMemberUpdateProfile(payload) {
    return this.commonApiService.post(
      APIURL.admin_organization_member_update_profile,
      payload,
    );
  }

  adminOrganizationJobs(payload) {
    return this.commonApiService.post(APIURL.admin_organization_jobs, payload);
  }

  adminInviteUser(payload) {
    return this.commonApiService.post(APIURL.admin_invite_user, payload);
  }

  resendInvite(payload) {
    return this.commonApiService.post(APIURL.admin_resend_invite, payload);
  }
}
